import { ElUploadInternalFileDetail } from 'element-ui/types/upload'
import JSZip from 'jszip'
import _ from 'lodash'
import { maxDragonBoneSize } from '@ps/utils/config'
import i18n from '@ps/lang'

export const isDragonBone = (
  file: ElUploadInternalFileDetail
): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    const zip = new JSZip()
    zip
      .loadAsync(file.raw)
      .then(function(zip) {
        const fileList = Object.values(zip.files).filter(file => {
          return !file.dir && !/^(__MACOSX)|(\.DS_Store)/.test(file.name)
        })
        if (
          fileList.length === 3 &&
          fileList.every(
            file =>
              file.name.endsWith('_tex.png') ||
              file.name.endsWith('_tex.json') ||
              file.name.endsWith('_ske.json')
          ) &&
          // 前缀必须一样
          _.uniq(
            fileList.map(file => {
              return file.name.replace(/(_tex.png)|(_tex.json)|(_ske.json)$/, '')
            })
          ).length === 1
        ) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
      .catch(err => {
        reject(new Error(err.message))
      })
  })
}

export async function validate(file: ElUploadInternalFileDetail) {
  if (file.raw.size > maxDragonBoneSize * 1024 * 1024) {
    return {
      valid: false,
      message: `文件大小不能超过${maxDragonBoneSize}M`,
      rule: 'size'
    }
  }
  if (!(await isDragonBone(file))) {
    return {
      valid: false,
      message:
        i18n.t('workbench.resourceManagers.dragonBone.required'),
      rule: 'file format'
    }
  }
  return {
    valid: true
  }
}
